import { FormFieldConfig } from '@shared/interfaces/config';
import { set } from 'lodash';

export const camelToSnake = (string): string => {
  return string
    .replace(/[\w]([A-Z])/g, function(m) {
      return m[0] + '_' + m[1];
    })
    .toLowerCase();
};

export const checkCondition = (fieldConfig: FormFieldConfig, entity): boolean => {
  if (fieldConfig.conditionalHide) {
    return entity[fieldConfig.conditionalHide.fieldPath] != fieldConfig.conditionalHide.value;
  }
  return true;
};

export const prepareToSave = (entityCopy, fieldsObject: Record<string, FormFieldConfig>) => {
  Object.values(fieldsObject).forEach(field => {
    if (field.inputType == 'entity-select' && !field.selectValue && entityCopy[field.fieldPath]) {
      let fieldValue = null;
      let fieldPath = field.fieldPath;
      if (field.selectMultiple) {
        fieldValue = entityCopy[field.fieldPath].map(function(element) {
          if (typeof element === 'object' && element !== null) {
            return element.id;
          } else {
            return element;
          }
        });
      } else {
        fieldValue = entityCopy[field.fieldPath]['id'];
        if (field.selectForeignKey) {
          fieldPath = field.selectForeignKey;
        } else {
          fieldPath = camelToSnake(fieldPath) + '_id';
        }
      }
      set(entityCopy, fieldPath, fieldValue);
    } else if (field.inputType == 'entity-table' && entityCopy.id) {
      entityCopy[field.fieldPath] = null;
    } else if (
      field.splitBeforeSend &&
      entityCopy[field.fieldPath] &&
      checkCondition(field, entityCopy)
    ) {
      // Si the field config has splitBeforeSend to true, then we split the value of this prop and put in the root of the model
      for (const key in entityCopy[field.fieldPath]) {
        if (entityCopy[field.fieldPath][key]) {
          entityCopy[key] = entityCopy[field.fieldPath][key];
        }
      }
    }
  });
  return entityCopy;
};

export const buildFormData = (data, formData: FormData, parentKey: string = '') => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      formData = buildFormData(data[key], formData, parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data === null ? '' : data;
    formData.append(parentKey, value);
  }
  return formData;
};

export const convertModelToFormData = (model: any, method: string = null) => {
  const formData = new FormData();
  if (method === 'put') {
    formData.append('_method', method);
  }
  return buildFormData(model, formData);
};
